import {
    DateFormat,
    differenceInYears,
    reformatDate,
} from '@superbet-group/web.lib.utilities';

// Copy isOverMaxAge until all forms are moved to fed such that tests don't fail.
export function isOverMaxAge(dateOfBirth: string, maxAge = 99): boolean {
    let birthDate = new Date(dateOfBirth);

    if (birthDate.toString() === 'Invalid Date') {
        birthDate = new Date(reformatDate(dateOfBirth, DateFormat.Slashddmmyyyy, DateFormat.Dashyyyymmdd));
    }

    const today = new Date();
    const age = differenceInYears(today, birthDate);

    return age > maxAge;
}

export function isUnderMinAge(dateOfBirth: string, minAge = 18): boolean {
    let birthDate = new Date(dateOfBirth);

    if (birthDate.toString() === 'Invalid Date') {
        birthDate = new Date(reformatDate(dateOfBirth, DateFormat.Slashddmmyyyy, DateFormat.Dashyyyymmdd));
    }

    const today = new Date();
    const age = differenceInYears(today, birthDate);

    return age < minAge;
}

export enum PasswordStrength {
    Weak = 0,
    Good = 1,
    Strong = 2,
}
